export function useGoogleMaps() {
  const googleInstance = ref<typeof google | undefined>(typeof google === 'undefined' ? undefined : google)
  const runtimeConfig = useRuntimeConfig()

  onMounted(() => {
    if (window.google) {
      googleInstance.value = window.google
    }
  })

  if (!googleInstance.value) {
    useHead({
      script: [{
        src: `https://maps.googleapis.com/maps/api/js?key=${runtimeConfig.public.googleMapApiKey}&libraries=places,marker`,
        async: true,
        key: 'google-maps-script',
        defer: true,
        onload() {
          if (!googleInstance.value) {
            googleInstance.value = window.google
          }
        },
      }],
    })
  }

  return googleInstance
}

declare global {
  interface Window {
    initGoogleMaps: () => void
  }
}
